/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './inventory_unit';
import '../../../common/time';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "Carton": {
                    "fields": {
                      "trackingUrl": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "trackingStatus": {
                        "type": "squareup.solidshop.v2.resources.Carton.TrackingStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tracking": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "inventoryUnit": {
                        "type": "squareup.solidshop.v2.resources.InventoryUnit",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "earliestArrival": {
                        "type": "squareup.common.time.DateTime",
                        "id": 5,
                        "rule": "optional"
                      },
                      "latestArrival": {
                        "type": "squareup.common.time.DateTime",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TrackingStatus": {
                        "values": {
                          "UNKNOWN": 0,
                          "PRE_TRANSIT": 1,
                          "IN_TRANSIT": 2,
                          "OUT_FOR_DELIVERY": 3,
                          "DELIVERED": 4,
                          "AVAILABLE_FOR_PICKUP": 5,
                          "RETURNED_TO_SENDER": 6,
                          "FAILURE": 7,
                          "ERROR": 8,
                          "CANCELLED": 9
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE Carton @ squareup/solidshop/v2/resources/carton.proto at 11:1
 */
export const Carton = $root.lookupType('squareup.solidshop.v2.resources.Carton');
fixType(Carton);
Builder.createAndAttachToType(Carton);
/**
 * Tracking status from Easypost
 *
 * SOURCE TrackingStatus @ squareup/solidshop/v2/resources/carton.proto at 13:3
 */
Carton.TrackingStatus = $root.lookupEnum('squareup.solidshop.v2.resources.Carton.TrackingStatus').values;
